import React, { useState } from "react";
import InforgraphicForm from "./InfographicForm";
import CustomModal from "../CustomModal";
import Button from "../Button";
import Card from "../Card";

const infographicData = {
  title: "Have you tried sensory toys to comfort your neurodivergent child?",
  body: "The holidays are just around the corner and you’re probably on the hunt for a memorable gift for your child. We’ve created a quick introduction on how sensory toys can help stimulate senses and engage your neurodivergent child in a way that they enjoy. Check out our infographic to know more.",
  thumbnail: "/infographics/Thumbnail1.jpg",
  previewImage: "/infographics/Thumbnail1.jpg",
  downloadUrl: "/infographics/infographic1.jpg",
  fileName: "social-spectrum-infographic",
};

const sensoryCards = [
  {
    n: "1",
    title: "Tactile Comfort",
    body: "Textured chewables, squish balls & sensory mats reduce anxiety through calming fingertip input.",
    tone: "bg-cloud-mist text-spectrum-blue",
  },
  {
    n: "2",
    title: "Auditory Regulating",
    body: "Rhythmic chimes, white-noise toys & soothing soundscapes support auditory processing.",
    tone: "bg-sunshine text-ink",
  },
  {
    n: "3",
    title: "Visual Soothing",
    body: "Liquid motion bubblers, slow colour lamps & glitter wands aid visual decompression.",
    tone: "bg-heart-teal text-surface-white",
  },
  {
    n: "4",
    title: "Deep Pressure",
    body: "Weighted lap pads & compression plushies promote proprioceptive grounding and focus.",
    tone: "bg-spectrum-blue text-surface-white",
  },
];

const InfographicCard = () => {
  const [showPreview, setShowPreview] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleDownload = async () => setShowModal(true);
  const handleModalContentClick = (e) => e.stopPropagation();

  return (
    <section className="bg-surface-white py-16 md:py-24 text-left w-full">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-10">
          <span className="inline-block bg-cloud-mist text-spectrum-blue text-xs font-bold tracking-wider px-3.5 py-1 rounded-brand mb-3 font-headline">
            SENSORY TOOLS & PLAY
          </span>
          <h2 className="font-headline text-3xl md:text-4xl text-ink leading-tight mb-4">
            <span className="font-light">Have you tried sensory toys to</span>
            <span className="font-extrabold text-spectrum-blue block sm:inline">
              {" "}
              comfort your neurodivergent child?
            </span>
          </h2>
          <p className="font-body text-muted text-[15px] md:text-[16px] leading-relaxed max-w-[620px]">
            {infographicData.body}
          </p>
        </div>

        <div className="bg-mist-gradient rounded-brand border border-cloud-mist p-6 sm:p-8 lg:p-10 shadow-brand-md mb-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 items-stretch">
            {sensoryCards.map((card) => (
              <Card key={card.n} variant="white" className="!p-5">
                <div
                  className={`w-10 h-10 rounded-brand flex items-center justify-center font-bold text-lg mb-3 font-headline ${card.tone}`}
                >
                  {card.n}
                </div>
                <h4 className="font-headline font-bold text-ink text-base mb-1.5">
                  {card.title}
                </h4>
                <p className="font-body text-muted text-xs leading-relaxed">
                  {card.body}
                </p>
              </Card>
            ))}
          </div>

          <div className="mt-8 pt-6 border-t border-cloud-mist flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <p className="text-xs font-semibold text-muted font-headline">
              Infographic Guide • Downloadable PDF (Print-Friendly A4)
            </p>
            <div className="flex items-center gap-3">
              <Button
                type="button"
                variant="secondary"
                size="sm"
                className="!bg-cloud-mist !border-0"
                onClick={() => setShowPreview(true)}
              >
                Preview
              </Button>
              <Button type="button" variant="primary" size="sm" onClick={handleDownload}>
                Download
              </Button>
            </div>
          </div>
        </div>
      </div>

      {showPreview && (
        <div
          className="bg-scrim fixed inset-0 flex items-center justify-center z-50"
          onClick={() => setShowPreview(false)}
          role="dialog"
          aria-modal="true"
          aria-label="Infographic preview"
        >
          <div
            className="relative min-w-[300px] w-[95vw] lg:w-[80vw] max-w-[2000px] mx-4"
            onClick={handleModalContentClick}
          >
            <img
              src={infographicData.previewImage}
              alt="Infographic Preview"
              className="w-full rounded-brand"
            />
            <button
              type="button"
              onClick={() => setShowPreview(false)}
              className="bg-scrim-soft absolute top-4 right-4 text-surface-white rounded-full w-10 h-10 flex items-center justify-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-blue"
              aria-label="Close preview"
            >
              ×
            </button>
          </div>
        </div>
      )}

      <CustomModal
        show={showModal}
        onClose={() => setShowModal(false)}
        title={"Submit Details to Download"}
        height={true}
      >
        <div className="w-full">
          <InforgraphicForm showModal={handleClose} data={infographicData} />
        </div>
      </CustomModal>
    </section>
  );
};

export default InfographicCard;
